module.exports = __webpack_public_path__ + "static/media/BandHuntWeb.5607ffd1.webm";